import React from "react";
import CreateNew from "MODULES/shared/containers/CreateNew";
import { createNew } from "MODULES/shared/decorators";
import { INTERNAL_NOTE } from "MODULES/shared/constants";
import { EXTERNAL_NOTE } from "MODULES/PurchaseOrders/constants";
import Modal from "MODULES/shared/components/Note/Modal";

export const EditInternalNote = createNew(
  (open, close, props) => (
    <Modal open={open} close={close} type={INTERNAL_NOTE} {...props} />
  ),
  props => <CreateNew {...props} />
);

export const EditExternalNote = createNew(
  (open, close, props) => (
    <Modal open={open} close={close} type={EXTERNAL_NOTE} {...props} />
  ),
  props => <CreateNew {...props} />
);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Note/Edit.jsx